export default "__VITE_ASSET__55c2b7aa__"